// extracted by mini-css-extract-plugin
export default {"image":"_3-z","loaded":"a4-z"};